var map = {
	"./advertising.svg": 1345,
	"./agriculture.svg": 1346,
	"./consumer.svg": 1347,
	"./consumergoods.svg": 1348,
	"./education.svg": 1349,
	"./entertainment.svg": 1350,
	"./fashion.svg": 1351,
	"./finance.svg": 1352,
	"./fintech.svg": 1353,
	"./food.svg": 1354,
	"./gaming.svg": 1355,
	"./greentech.svg": 1356,
	"./healthcare.svg": 1357,
	"./hightech.svg": 1358,
	"./hospitality.svg": 1359,
	"./impact.svg": 1360,
	"./impacttech.svg": 1361,
	"./iot.svg": 1362,
	"./itsoftware.svg": 1363,
	"./jobs.svg": 1364,
	"./legal.svg": 1365,
	"./manufacturing.svg": 1366,
	"./maritime.svg": 1367,
	"./marketplace.svg": 1368,
	"./media.svg": 1369,
	"./music.svg": 1370,
	"./retail.svg": 1371,
	"./robotics.svg": 1372,
	"./saas.svg": 1373,
	"./sales.svg": 1374,
	"./science.svg": 1375,
	"./service.svg": 1376,
	"./software.svg": 1377,
	"./sports.svg": 1378,
	"./telecommunications.svg": 1379,
	"./travel.svg": 1380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1344;